<template>
    <div class="training-record">
      <h2 v-if="!(templateData && templateData.training_type === 'rich_text')" style="font-size: 0.8rem;">TOOLBOX {{ templateData && templateData.training_box }}</h2>
      <h3 v-if="!(templateData && templateData.training_type === 'rich_text')">{{ templateData && templateData.type }}</h3>
      <div style="float: right; position: absolute; top: 0; right: 10px;"><img src="@/assets/new_logo.png" style="width: 100px;object-fit: contain;" /></div>

      <!-- 富文本内容区域 -->
      <div class="rich-content-section" v-if="templateData && templateData.training_type === 'rich_text' && templateData.content">
        <div class="rich-content-body" v-html="templateData.content"></div>
      </div>

      <!-- 原有培训内容（非富文本时显示） -->
      <div class="training-content" v-else>
        <div class="training-row">
          <div class="label">培训日期</div>
          <div class="value">{{ templateData && templateData.training_date }}</div>
        </div>
        <div class="training-row high-training-row">
          <div class="label high-label">培训方式</div>
          <div class="value">
            <div>
              <label class="custom-checkbox">
                <van-icon name="success" />培训材料
              </label>
              <label class="custom-checkbox">
                <van-icon name="success" /> 现场培训
              </label>
            </div>
            <div style="text-align: left; padding-left: 37px;">
              <label class="custom-checkbox">
                培训视频
              </label>
            </div>
          </div>
        </div>
        <div class="training-row section-title">
          <div class="full-width">公司级安全教育(月度常规培训)：{{ templateData && templateData.training_title ? templateData.training_title : '' }}</div>
        </div>
        <div class="training-row training-row-content">
          <div class="training-content-item" v-for="(item, index) in trainingContent" :key="index">
            <div>{{ index + 1 }}、{{ item }}</div>
          </div>
        </div>
        <div class="training-row">
          <div class="label">培训者</div>
          <div class="value">{{ templateData && templateData.trainer ? templateData.trainer : '设施维护部-杨园园' }}</div>
        </div>
        <div class="declaration">
          <p style="text-align: left; margin: 10px;">本人已全程参加了公司组织的本次员工月度安全培训，知悉并了解本次培训的全部内容，本人承诺在工作中将严格遵守安全操作规范等公司安全管理制度。</p>
        </div>

        <div class="notes">
          <h4>说明：</h4>
          <ol>
            <li>凡未经月度培训的人员，禁止独立上岗操作。</li>
            <li>月度安全教育培训时间不得少于1小时。</li>
            <li>培训者、受培训者必须由本人签字。</li>
          </ol>
        </div>
      </div>

      <!-- 签字区域（始终显示） -->
      <div :class="['sign-section', isRichText ? 'sign-section-plain' : '']">
        <div class="signature-area" @click="showSign">
          <p v-if="!isRichText">参加培训员工签字：</p>
          <div v-if="pictureUrl" class="sign-name-picture">
            <van-image
              fit="contain"
              style="width: 40vw; height: 10vh;"
              :src="pictureUrl"
            />
          </div>
          <div v-if="!pictureUrl" class="sign-name-picture">
            <van-button @click="showSign" type="primary">点击签名</van-button>
          </div>
        </div>
        <div class="sign-sure-btn" v-if="pictureUrl">
          <van-button @click="submitSign" type="primary">确认</van-button>
        </div>
      </div>

      <!-- 底部当前时间 -->
      <div class="current-time-section" style="text-align: right;">
        <span>{{ currentDateTime }}</span>
      </div>

      <van-popup
        v-model="show"
        closeable
        position="bottom"
        :style="{ height: '100%' }"
      >
        <sign-name @setShow="hideShow" />
      </van-popup>
    </div>
  </template>

  <script>
  import dayjs from "dayjs";
  import SignName from "./components/sign_name.vue";
  import {getBaseInfo, postNewContract, getTrainingTemplate} from "../../api/user";
  import {Toast} from "vant";

  export default {
    components: {SignName},
    data() {
      return {
        show: false,
        addShow: false,
        templateId: null, // 从路由参数获取的模板ID
        templateData: null, // API返回的模板数据
        trainingDate: "2025年5月26日",
        trainingMethods: ["material", "video", "onsite"],
        trainingContent: [
          "相关ISE法律法规",
          "个人操作工具",
          "危险作业操作",
          "应急相应操作流程",
          "相关案例"
        ],
        trainer: "",
        signature: "",
        pictureUrl: "",
        fileId: 0,
        isSubmitting: false, // 添加提交状态控制变量
        currentDateTime: dayjs().format('YYYY年MM月DD日 HH:mm'),
        timer: null,
      };
    },
    async created() {
      // 从路由参数获取id
      this.templateId = this.$route.query.id;

      getBaseInfo();
      if (localStorage.getItem('name')) {
        this.trainer = localStorage.getItem('name')
      }

      // 如果有模板ID，调用API获取模板数据
      if (this.templateId) {
        try {
          const result = await getTrainingTemplate(this.templateId);
          console.log('resultresultresult', result);
          if (result.code === 0) {
            this.templateData = result.data;
            // 根据API返回的数据更新页面内容
            this.updatePageContent();
          } else {
            Toast.fail('获取培训模板失败');
          }
        } catch (error) {
          console.error('获取培训模板出错:', error);
          Toast.fail('获取培训模板失败');
        }
      }

      // 每分钟更新当前时间
      this.timer = setInterval(() => {
        this.currentDateTime = dayjs().format('YYYY年MM月DD日 HH:mm');
      }, 60000);
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    computed: {
      isRichText() {
        return this.templateData && this.templateData.training_type === 'rich_text';
      }
    },
    methods: {
       /**
        * 根据API返回的数据更新页面内容
        */
       updatePageContent() {
         if (this.templateData) {
           // 更新培训日期
           if (this.templateData.training_date) {
             this.trainingDate = this.templateData.training_date;
           }

           // 更新培训内容
           if (this.templateData.training_content && Array.isArray(this.templateData.training_content)) {
             this.trainingContent = this.templateData.training_content;
           }

           // 更新培训者
           if (this.templateData.trainer) {
             this.trainer = this.templateData.trainer;
           }
         }
       },

       toggleTrainingMethod(method) {
         const index = this.trainingMethods.indexOf(method);
         if (index === -1) {
           this.trainingMethods.push(method);
         } else {
           this.trainingMethods.splice(index, 1);
         }
       },
      async submitSign() {
         if (this.isSubmitting) return; // 如果正在提交中，直接返回
         this.isSubmitting = true; // 设置提交状态

         try {
           const submitData = {
             contract_id: this.templateId,
             contract_file_id: this.fileId
           };

           const result = await postNewContract(submitData);
           if (result.code === 0) {
             Toast.success('提交成功')
             this.show = false
           } else {
             Toast.fail('提交失败')
           }
         } catch (error) {
           Toast.fail('提交失败')
         }

         // 2秒后才允许再次提交
         setTimeout(() => {
           this.isSubmitting = false;
         }, 2000);
       },
      hideShow(content) {
        console.log('event.....', content)
        if (content) {
          this.pictureUrl = content.url
          this.fileId = content.file_id
        }
        this.show = false
      },
      showSign() {
        this.show = true
      },
    }
  };
  </script>

  <style scoped>
  .training-record {
    max-width: 800px;
    width: 100%;
    margin: 20px auto;
    font-family: 'SimSun', sans-serif;
    padding: 20px;
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    .training-record {
      margin: 10px auto 0;
      padding: 10px;
      position: relative;
    }
  }

  h3 {
    text-align: center;
    margin: 10px 0;
  }
  h2 {
    text-align: left;
  }

  .training-content {
    width: 100%;
    margin: 15px 0;
    border: 1px solid #000;
  }

  .training-row {
    border-bottom: 1px solid #000;
    overflow: hidden;
  }

  .training-row:last-child {
    border-bottom: none;
  }

  .label {
    width: 120px;
    font-weight: bold;
    background-color: #f0f0f0;
    float: left;
    padding: 8px;
    border-right: 1px solid #000;
  }

  .value {
    float: left;
    padding: 8px;
  }

  .full-width {
    width: 100%;
    padding: 8px;
  }

  .section-title {
    font-weight: bold;
    background-color: #f0f0f0;
  }

  .training-row-content {
    padding: 10px 0;
  }

  .declaration {
    border-bottom: solid 1px;
  }

  .rich-content-section {
    width: 100%;
    margin: 15px 0;
    padding: 10px;
    box-sizing: border-box;
  }

  .rich-content-body {
    text-align: left;
    line-height: 1.6;
    word-break: break-all;
  }

  .rich-content-body >>> img {
    max-width: 100%;
    height: auto;
  }

  .sign-section {
    margin: 15px 0;
    border: 1px solid #000;
    padding: 10px;
  }

  .sign-section-plain {
    border: none;
    padding: 10px 0;
  }

  .current-time-section {
    padding: 10px;
    font-size: 14px;
    color: #333;
  }

  .custom-checkbox {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
  }

  .custom-checkbox .van-icon {
    font-size: 20px;
    margin-right: 5px;
  }

  .custom-checkbox .van-icon.checked {
    color: #1989fa;
  }

  .training-content-item {
    text-align: left;
    margin-left: 10px;
  }

  .signature-area {
    text-align: left;
    font-weight: bold;
    margin-left: 20px;
  }

  .section-title {
    text-align: left;
    padding-left: 20px;
  }
  .notes {
    margin-bottom: 20px;
  }

  .notes h4 {
    text-align: left;
    margin: 10px 10px 0;
  }

  .notes li {
    text-align: left;
    margin-left: 20px;
  }

  @media (max-width: 768px) {
    .sign-sure-btn {
      margin-bottom: 10px;
    }
    .signature-area {
      position: relative;
    }
    .sign-name-picture {
      position: absolute;
      top: 0;
      right: 10px;
    }
    .h2 {
      font-size: 1rem;
    }
    .training-content {
    }

    .training-row {
      overflow: hidden;
    }
    .label {
      background: none;
      float: left;
      padding: 5px 0;
      width: 30%;
    }
    .high-label {
      height: 50px;
      line-height: 50px;
    }
    .high-training-row {
      height: 50px;
    }

    .value {
      padding: 5px 5px;
      float: left;
      width: 66%;
    }

    .full-width {
      padding: 5px 0;
    }

    .section-title {
      background: #f0f0f0;
      padding: 5px;
      text-align: left;
    }

    .notes h4 {
      text-align: left;
      margin: 2px 10px 0;
    }
  }

  .signature-area {
    margin-top: 20px;
    min-height: 100px;
  }

  .signature-area input {
    width: 200px;
    border-bottom: 1px solid #000;
    margin-left: 20px;
  }

  @media (max-width: 768px) {
    .training-row-content {
      padding: 5px 0;
    }
    .custom-checkbox {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
  }

  .custom-checkbox .van-icon {
    font-size: 20px;
    margin-right: 5px;
  }

  .custom-checkbox .van-icon.checked {
    color: #1989fa;
  }

  .training-content-item {
      border: none;
      text-align: left;
      margin-left: 10px;
    }
    .signature-area input {
      width: 100%;
      margin-left: 0;
      margin-top: 10px;
    }

    .signature-area p {
      margin-bottom: 5px;
    }

    .notes ol {
      margin-left: 10px;
      padding-left: 15px;
    }

    h2 {
      font-size: 1em;
    }

    h3 {
      font-size: 1.5em;
    }

    .notes {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .declaration p {
      font-size: 0.9em;
      line-height: 1.4;
    }
    .declaration {
      border-bottom: solid 1px;
    }
    .signature-area p {
      font-weight: bold;
      text-align: left;
      margin-left: 20px;
      margin-bottom: 40px;
    }
  }

  .notes {
    margin-top: 2px;
  }

  ol {
    margin-left: 20px;
  }
  </style>



// WEBPACK FOOTER //
// src/views/user/new_sign.vue